module.exports = __webpack_public_path__ + "img/card-master.e940b5cc.png";